import React from 'react';

import { useCopyStore } from 'store';
import { ReactComponent as LogoIcon } from 'svgs/logoRotateDeviceScreen.svg';
import { isMobile, isTablet } from 'u9/utils/platform';

import * as Styled from './RotateDeviceComponent.styles';

export interface RotateDeviceComponentProps {}

const defaultProps: Partial<RotateDeviceComponentProps> = {};

const RotateDeviceComponent: React.FC<RotateDeviceComponentProps> = () => {
  const {
    copy: { global },
  } = useCopyStore();

  return (
    <Styled.Wrapper>
      <Styled.LogoWrapper>
        <LogoIcon tabIndex={0} />
      </Styled.LogoWrapper>
      <Styled.Container>
        <Styled.IconWrapper>
          <Styled.Icon
            src={
              isMobile()
                ? '/images/rotateMobile.png'
                : isTablet() && '/images/rotateTablet.png'
            }
          />
        </Styled.IconWrapper>
        <Styled.Title
          dangerouslySetInnerHTML={{
            __html: isMobile()
              ? global.errors.rotateDevice.body.mobile
              : isTablet() && global.errors.rotateDevice.body.tablet,
          }}
        />
      </Styled.Container>
    </Styled.Wrapper>
  );
};

RotateDeviceComponent.defaultProps = defaultProps;

export default RotateDeviceComponent;
